import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import MyContributionsPreview from './MyContributionsPreview';
import HistoricalPreview from './MyApprovalsPreview';
import { useAxios } from '../../../../../context/AxiosContext';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Card, Col, Row } from 'react-bootstrap';

import '../../MyReviews/Activity/ActivityMyReviews.css';
import MyComplexityInfo from "../../../MyComplexityInfo";

const ActivityMyApprovals = () => {
	const { axiosGetService } = useAxios();
	const history = useHistory();
	const { artifactType, id, artifactId, stateId } = useParams();
	const [existingHashtags, setExistingHashtags] = useState([]);
	const myReviewsTab = ['Historical Preview', 'Your Contributions'];
	const [activeTab, setActiveTab] = useState('Historical Preview');
	const artifact = {
		'Historical Preview': <HistoricalPreview />,
		'Your Contributions': <MyContributionsPreview />,
	};
	const complexityId = Number(
		queryString.parse(window.location.search).complexity
	);
	const [complexities, setComplexities] = useState([]);
	const [complexityName, setComplexityName] = useState({
		name: '',
		type: 'option',
		id: '',
	}); const [showComplexityInfoModal, setShowComplexityInfoModal] = useState(false);
		  const [hoveredButton, setHoveredButton] = useState(null);
		  let timeoutId;
	const [activityContent, setActivityContent] = useState(null);
	const [contributorsData, setContributorsData] = useState(null);
	const [noContribution, setNoContribution] = useState(null);
	const getActivityContents = async () => {
		await axiosGetService(
			`api/sdmactivity/getactivityapproverspreview?id=${id}&activityId=${artifactId}&complexityId=${complexityId}`
		)
			.then((response) => {
				if (!response.data) {
					setNoContribution('noData');
				} else {
					setContributorsData(response.data);
					const hashtags = response.data.hashTagsList?.map(({ name }) => name) || [];
					setExistingHashtags(hashtags);
					setActivityContent(JSON.parse(response.data.activityContent));
					const mappedComplexities = [
						{
							name: response.data.complexityName,
							id: response.data.complexityId,
							option: 'type',
						},
					];
					setComplexityName({
						name: response.data.complexityName,
						id: response.data.complexityId,
						type: 'option',
					});




				}

			})
			.catch((err) => {
				console.log(err);
			});
	};
	const getActivityContentsconto = async () => {
		await axiosGetService(
			`api/sdmactivity/getactivityreviewerorapprovercontribution?id=${id}&activityId=${artifactId}&complexityId=${complexityId}&stateId=${stateId}`
		)
			.then((response) => {
				if (!response.data) {
					setNoContribution('noData');
				} else {
					setContributorsData(response.data);
					const hashtags = response.data.hashTagsList.map(({ name }) => {
						return name;
					});
					setExistingHashtags(hashtags);
					setActivityContent(JSON.parse(response.data.activityContent));
					const mappedComplexities = [
						{
							name: response.data.complexityName,
							id: response.data.complexityId,
							option: 'type',
						},
					];
					setComplexityName({
						name: response.data.complexityName,
						id: response.data.complexityId,
						type: 'option',
					});





				}

			})
			.catch((err) => {
				console.log(err);
			});
	};
	useEffect(() => {
		getComplexities();
		console.log(activeTab, "linehistory");
		if (activeTab === 'Historical Preview') {
			getActivityContents();
		}
		else if (activeTab === 'Your Contributions') {
			getActivityContentsconto();

		}
	}, [activeTab]);
	const handleMouseEnter = (id) => {
		clearTimeout(timeoutId);
		setHoveredButton(id);
		setShowComplexityInfoModal(true);
	  };
	
	  const handleMouseLeave = () => {
		timeoutId = setTimeout(() => {
		  setShowComplexityInfoModal(false);
		  setHoveredButton(null);
		}, 200); // Small delay to allow moving to tooltip
	  };
	const getComplexities = async () => {
		await axiosGetService(`api/activities/projectcomplexity`).then((res) => {
			const data = res.data.map((item) => {
				return {
					name: item.name,
					id: item.id,
					option: "type",
				};
			});
			setComplexities(data);

		});
	};
	return (
		<>
			{/* Complexity Section */}
			<Row className={`mr-0 d-flex flex-wrap _rowGray _RealizedDivStyle`}  style={{position: "relative"}}>
			<Col xs={12} sm={12} md={5} className="px-0">
          <div className={`_complexityContainer _complexityContainerUpdateForRealize pl-3 pt-0 pb-0`}>
            <span>Complexity&nbsp;:</span>

            <div
              className={`_complexityButtonsContainer ${complexities.length > 1 ? "" : "_complexityButtonsContainerSingle"}`}
              style={{  position: "relative", zIndex: 10 }} // Ensure relative position to parent container
            >
              {complexities?.map((complexity) => (
                <>            <button 
                  onMouseEnter={() => handleMouseEnter(complexity.id)}
                  onMouseLeave={handleMouseLeave}
                  className={`_ComplexityLatestContribution _complexityButtons ${complexityName.id === complexity.id ? "_activeComplexityButtons" : ""}`}
                >
                  {complexity?.name}
                </button>

                  {/* Tooltip for Complexity Info */}
                  {
                    showComplexityInfoModal && complexity?.name === 'Medium/Low'
                    && (

                      <MyComplexityInfo />
                    )}
                </>

              ))}
            </div>

          </div>
        </Col>

				{/* Discard and Publish Buttons */}
				<Col
					xs={12}
					sm={12}
					md={7}
					className=" _FeedbackDivActvity d-flex justify-content-end align-items-center px-0 mr-0"
				>
					<div className="discardAndPreviewButton mr-0">
						<Button
							title="Discard"
							className="activityDiscardButton  _Publish_Disable"
							tabIndex={0}
							disabled={true}
						>
							Discard
						</Button>
						<Button
							title="Preview &amp; Publish"
							className="activityPreviewButton _Previewbtns _Publish_Disable"
							tabIndex={0}
							disabled={true}
						>
							Preview &amp; Publish
						</Button>
					</div>
				</Col>
			</Row>

			{/* Activity Details */}
			<Row className="">
				<Col
					xs={12}
					sm={12}
					md={12}
					className={``}
				>
					<Card className={``}>

						<Row className={`ml-3 mt-3`}>
							<Col className="pl-2">
								<h1 title={contributorsData?.activityName} className="activityLandingPageTitle _activityLandingPageTitle mb-0">{contributorsData?.activityName}</h1>
							</Col>
						</Row>
						<Row className="mx-2">

							{contributorsData && <span className="_activityVersion pr-4 pl-3">
								{`Document Version: ${contributorsData?.activityVersion},`}
								&nbsp;&nbsp;
								{contributorsData?.date}
							</span>}
						</Row>
						<Row className="mr-2 ml-3">
							<Col className="existingHashTagsOfActivity _existingHashTagsOfActivity paddingForHashtags">
								{existingHashtags.map((name) => (
									<span
										key={name}
										onClick={() => {
											history.push(
												`/search?searchParam=${encodeURIComponent(name)}`
											);
										}}
										onKeyPress={(e) => {
											if (e.which === 13) {
												history.push(
													`/search?searchParam=${encodeURIComponent(name)}`
												);
											}
										}}
									>
										{name}
									</span>
								))}
							</Col>
						</Row>
						<Row className="mx-2">
							<Col className='px-0'>
								<div className="myContributionPreviewContainer pr-0">
									<div className="myContributionsRightContent">
										<div className="myContributionsContentMenuContainer Activty_MainContainer">
											<ul
												className="myContributionsContentMenuTabs"
												id="myContributionsContentMenuTabsId"
											>
												{myReviewsTab.map((tab) => (
													<li
														tabIndex={0}
														onKeyPress={(e) => {
															if (e.which === 13) {
																setActiveTab(tab);
															}
														}}
														onClick={() => setActiveTab(tab)}
														className={
															activeTab === tab
																? 'activeMyContributionCrowdSourcingTab'
																: null
														}
													>
														{tab}
													</li>
												))}
											</ul>
										</div>
									</div>
									{artifact[activeTab]}
								</div>
							</Col>
						</Row>
					</Card>
				</Col>
			</Row>

			{/* Tab Section */}

		</>

	);


};

export default ActivityMyApprovals;
